import axios from "axios";

const api = axios.create({ baseURL: "https://api.meuroom.com.br" });


export default api;
